import * as React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandIcon from '../../assets/expand-more.svg';
import ShrinkIcon from '../../assets/expand-less.svg';

const CustomExpandIcon = () => {
    return (
        <Box>
        <div className="expandIconWrapper icon" style={{ backgroundImage: `url(${ExpandIcon})`}}></div>
        <div className="collapsIconWrapper icon" style={{ backgroundImage: `url(${ShrinkIcon})`}}></div>
        </Box>
    );
};

const Accordion = styled(MuiAccordion)(({ theme }) => ({
    boxShadow: 'none',
    '& .Mui-expanded:not(:first-of-type)::after':{
        position: 'absolute',
        left: '0',
        top: '-1px',
        right: '0',
        height: '1px',
        content: '""',
        opacity: '1',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        // -webkitTransition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
     },
    '& .root-title .Mui-expanded :before':{
        position: 'absolute',
        left: '0',
        top: '1px',
        right: '0',
        height: '1px',
        content: '""',
        opacity: '1',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        // -webkitTransition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
     },

  }));

const AccordionNodes = [{
    id: "panel1",
    name: "About Finance Management Associate (FMA) Program",
    children: [{
            id: "panel1a",
            name: "What is the distinction between the Finance Management Associate (FMA) Program and the Sea Global Management Associate Program (GMAP)?",
            desc1: "The FMA Program is a specialized program for graduates who want to build a career in Finance, offering exposure across accounting and finance functions while developing capabilities in the technologies shaping the field. GMAP offers a broad experience through global exposure and cross-business rotations in varied functions of Sea’s core business — Garena, Shopee and Monee.",
            desc2: "<br/>Both programs offer unique opportunities, catering to different career aspirations and pathways. Applicants are encouraged to consider their interests and goals to determine which program aligns best with their professional goals."
        },{
            id: "panel1d",
            name: "How will the program develop FMAs from different academic backgrounds?",
            desc1: "The program brings together graduates with different starting strengths and develops the complementary capabilities needed for a future-ready career in finance.",
            desc2: "<br/>FMAs with Accounting and Finance backgrounds can expect to deepen their functional expertise while expanding their exposure to data, AI and technology.",
            desc3: "<br/>FMAs with Computer Science, Data and AI backgrounds can expect to build accounting and finance foundations while learning how their technical capabilities can be applied to real finance challenges."
        },,{
            id: "panel1b",
            name: "How are rotations determined during the two-year program?",
            desc1: "Rotations are determined based on your interests, strengths, development needs, business priorities and available opportunities throughout the two-year program."
        },{
            id: "panel1c",
            name: "What happens after completing the two-year program?",
            desc1: "Based on your performance during the program, you will be considered for a permanent role. Your placement will take into account your strengths, career interests, team fit, business needs and available opportunities."
        }
    ]
},{
    id: "panel2",
    name: "About the application process",
    children: [{
        id: "panel2a",
        name: "When can I apply for FMA 2027?",
        desc1: "Applications are open from 18 Aug 2026 to 31 Oct 2026, 23:59 (SGT)."
    },{
        id: "panel2b",
        name: "Can I apply for both the Sea Global Management Associate Program and Finance Management Associate Program?",
        desc1: "Kindly note that:",
        desc2: "<br/>(1) You may apply for the 2027 Sea Global Management Associate Program (Shopee & Monee Track) alongside your 2027 FMA Program application. If you do so, kindly note that you can only be considered for 1 role at a time across both programs, based on your preference indicated.",
        desc3: "<br/>(2) You may apply for the 2027 Sea Global Management Associate Program (Garena Track) alongside your 2027 FMA Program application. If you do so, kindly note that you will be considered and assessed for both programs concurrently, and will need to select one program to proceed with in the later stages of the interview process.",
        desc4: "<br/>As each program is targeted at different growth areas, we encourage you to carefully consider your professional interests and career goals before deciding which program to apply for.",
        desc5: "<br/>Learn more about the Global Management Associate Program <a href='http://seamap.sea.com' target='_blank'>here</a>."
    },{
        id: "panel2c",
        name: "I have applied for a specific program but have now decided to choose a different program. What should I do?",
        desc1: "Should you decide to change your selection, please email <a href='mailto:financehr-recruitment@sea.com'>financehr-recruitment@sea.com</a> before the application deadline on 31 Oct 2026. However, do note that requests for change will be considered on a case-by-case basis."
    },]
},{
    id: "panel3",
    name: "About the selection criteria",
    children: [{
        id: "panel3a",
        name: "Who is FMA open to?",
        desc1: "FMA is open to graduating students*, recent graduates, and early-career candidates with less than 2 years of full-time working experience (as of the last day of the application window).",
        desc2: "<br/>*Graduating students should have completed or be on track to complete your degree no later than July 2027, and are able to join us full-time by August 2027."
    },{
        id: "panel3b",
        name: "Which academic backgrounds are eligible for FMA?",
        desc1: "The FMA Program welcomes candidates from Accounting, Finance, Computer Science, Data, AI and related fields.",
        desc2: "<br/>Candidates may bring financial foundations, technical capabilities or a combination of both. What matters is a strong interest in building a career in Finance and the willingness to develop capabilities across both Finance and technology."
    },{
        id: "panel3c",
        name: "What do you look for in a Management Associate?",
        desc1: "While strong academic performance is valued, we also prioritize specific qualities and characteristics in candidates. We are seeking individuals who demonstrate excellent communication and team spirit, strong drive and ownership, sharp analytical thinking, adaptability and a self-starter mindset.",
        desc2: "<br/>Learn more about the selection criteria <a href='#looking-for'>here</a>."
    }]
},{
    id: "panel4",
    name: "About the selection process",
    children: [{
        id: "panel4a",
        name: "Are the interview rounds conducted face-to-face or virtually?",
        desc1: "Most of the interview rounds will be conducted in person. Shortlisted candidates will receive further details about the interview format."
    },{
        id: "panel4b",
        name: "I am currently studying overseas. Can I still apply for FMA?",
        desc1: "Yes, you can still apply for FMA. However, please note that the interviews will be scheduled based on Singapore timezone (GMT +8)."
    },{
        id: "panel4c",
        name: "When can I expect to receive an offer?",
        desc1: "Successful candidates can expect to receive an offer by December 2026."
    }]
},{
    id: "panel5",
    name: "Other questions",
    children: [{
        id: "panel5a",
        name: "Who can I contact if I have more questions?",
        desc1: "For further queries, please contact <a href='mailto:financehr-recruitment@sea.com'>financehr-recruitment@sea.com</a>. We look forward to your application!"
    }]
}];


const renderChildren = (children) => {
    return (
        <>
        {children.map((c) => (
        <Accordion key={c.id}>
            <AccordionSummary expandIcon={<CustomExpandIcon />} id={c.id + '-header'} aria-controls={c.id + '-content'} className='child-title'>
                <p>{c.name}</p>
            </AccordionSummary>
            <AccordionDetails className='content'>
                <p dangerouslySetInnerHTML={{__html: c.desc1}}></p>
                {c.desc2 ? <p dangerouslySetInnerHTML={{__html: c.desc2}}></p> : null}
                {c.desc3 ? <p dangerouslySetInnerHTML={{__html: c.desc3}}></p> : null}
                {c.desc4 ? <p dangerouslySetInnerHTML={{__html: c.desc4}}></p> : null}
                {c.desc5 ? <p dangerouslySetInnerHTML={{__html: c.desc5}}></p> : null} 
            </AccordionDetails>
        </Accordion>
        ))}
        </>
    );
};
  
const renderNode = (AccordionNodes) => {
    return (
    <>
    {AccordionNodes.map((an) => (
        <Accordion key={an.id} >
            <AccordionSummary expandIcon={<CustomExpandIcon />} id={an.id + '-header'} aria-controls={an.id + '-content'} className='root-title'>
            <p>{an.name}</p>
            </AccordionSummary>
            <AccordionDetails>
            {renderChildren(an.children)}
            </AccordionDetails>
        </Accordion>
    ))}
    </>
    );
};

function FAQ(){
    return (
        <Box className='wrapper faq' id='FAQ'>
            <h2 className="section-title">You May Want to Find Out...</h2>
            <Box>
                {renderNode(AccordionNodes)}
            </Box>
        </Box>
    );
}
export default FAQ;